export default __webpack_public_path__ + "static/logo.berufsreise-5b8d93008d0e8eca745eb94bdaf3eff2.png";